const getFamilyColors = (product, config) => {
  const { getFamilyColorsHtml } = window.smk.product;
  const {
    containersRef = {
      color: '.content-select-colors',
      wrapper: '.content-product-template-wrapper'
    }
  } = config;

  return getFamilyColorsHtml(product.handle)
  .then(function(html) {
    if(containersRef.color) {
      $(containersRef.color).html($('ul', $(html)));
    }
  });
}

